export const MENU_CATEGORIES = [
  { id: "aperitive", label: "Aperitive" },
  { id: "supe", label: "Supe & Ciorbe" },
  { id: "principale", label: "Preparate Principale" },
  { id: "deserturi", label: "Deserturi" },
  { id: "bauturi", label: "Băuturi" },
];

export const MENU = {
  aperitive: [
    {
      name: "Foie Gras Maison",
      desc: "Foie gras de rață cu gem de smochine și brioche prăjit",
      price: "89 lei",
    },
    {
      name: "Tartare de Somon",
      desc: "Somon proaspăt, avocado, capere, sos citric",
      price: "67 lei",
    },
    {
      name: "Escargots à la Bourguignonne",
      desc: "Melci de Burgundia cu unt de usturoi și pătrunjel",
      price: "72 lei",
    },
    {
      name: "Carpaccio de Vită",
      desc: "Mușchi de vită, parmezan, rucola, trufe",
      price: "74 lei",
    },
  ],
  supe: [
    {
      name: "Soupe à l'Oignon",
      desc: "Supă clasică franțuzească de ceapă cu crutoane și Gruyère",
      price: "42 lei",
    },
    {
      name: "Velouté de Ciuperci",
      desc: "Cremă de ciuperci sălbatice cu ulei de trufe",
      price: "38 lei",
    },
    {
      name: "Bisque de Homard",
      desc: "Supă cremă de homar cu smântână și coniac",
      price: "58 lei",
    },
  ],
  principale: [
    {
      name: "Magret de Canard",
      desc: "Piept de rață cu sos de portocale și cartofi Dauphinoise",
      price: "124 lei",
    },
    {
      name: "Filet de Boeuf Rossini",
      desc: "Mușchi de vită cu foie gras și sos Périgueux",
      price: "168 lei",
    },
    {
      name: "Sole Meunière",
      desc: "File de pește cu unt brun, lămâie și pătrunjel",
      price: "136 lei",
    },
    {
      name: "Ratatouille Provençale",
      desc: "Legume mediteraneene cu sos de roșii și busuioc (vegetarian)",
      price: "78 lei",
    },
    {
      name: "Coq au Vin",
      desc: "Pui înăbușit în vin roșu cu ciuperci și legume",
      price: "112 lei",
    },
  ],
  deserturi: [
    {
      name: "Crème Brûlée",
      desc: "Clasică, cu vanilie Bourbon și caramel crocant",
      price: "44 lei",
    },
    {
      name: "Mousse au Chocolat",
      desc: "Ciocolată belgiană neagră 70%, chantilly",
      price: "46 lei",
    },
    {
      name: "Tarte Tatin",
      desc: "Tartă răsturnată cu mere caramelizate și înghețată de vanilie",
      price: "48 lei",
    },
    {
      name: "Profiteroles",
      desc: "Cu înghețată de vanilie și sos de ciocolată caldă",
      price: "42 lei",
    },
  ],
  bauturi: [
    {
      name: "Vin roşu — Château Margaux 2018",
      desc: "Bordeaux, Franţa",
      price: "380 lei / sticlă",
    },
    {
      name: "Vin alb — Sancerre 2021",
      desc: "Loire, Franţa",
      price: "290 lei / sticlă",
    },
    {
      name: "Şampanie — Moët & Chandon Impérial",
      desc: "Épernay, Franţa",
      price: "420 lei / sticlă",
    },
    {
      name: "Apă minerală",
      desc: "Plată sau carbogazoasă",
      price: "18 lei",
    },
    {
      name: "Cafea espresso",
      desc: "Selecţie din boabe italieneşti, prăjire artizanală",
      price: "22 lei",
    },
  ],
};
